import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import SidebarNavigation from "./SidebarNavigation"
import { tagTitles, tagTitlesSpanish } from "../utilities/TagTitles"

const SidebarNavigationTopics = ({
  currentPageId,
  alwaysOpen,
  languageCode,
}) => {
  const { allWpPage } = useStaticQuery(graphql`
    query PatientTopicChildPagesByParentIdAndTemplate {
      allWpPage(
        filter: {
          parentId: { eq: "cG9zdDo1OQ==" }
          template: { templateName: { eq: "Topic" } }
        }
        sort: { menuOrder: ASC }
      ) {
        edges {
          page: node {
            title
            id
            uri
            tags {
              nodes {
                id
                name
              }
            }
            customFields {
              navigationTitle
            }
            translations {
              title
              id
              uri
              customFields {
                navigationTitle
              }
            }
          }
        }
      }
    }
  `)

  const topicsByTag = allWpPage.edges?.reduce((group, edge) => {
    const tag = edge.page.tags.nodes.length && edge.page.tags.nodes[0].name
    group[tag] = group[tag] ?? []
    group[tag].push(edge)
    return group
  }, {})

  return tagTitles.map((topic, index) => {
    return (
      <SidebarNavigation
        pages={topicsByTag[topic]}
        currentPageId={currentPageId}
        title={languageCode === "es" ? tagTitlesSpanish[index] : topic}
        alwaysOpen={alwaysOpen}
        key={topic}
        languageCode={languageCode}
      />
    )
  })
}

export default SidebarNavigationTopics
